/** Class strings shared by the Service Desk pages, kept in one place so the controls match. */

export const SD_INPUT =
  'w-full rounded-md border border-amp-line bg-amp-white px-2 py-1.5 text-[13px] text-amp-ink placeholder:text-amp-ink-muted dark:border-amp-dark-line dark:bg-amp-dark-surface dark:text-amp-dark-ink';

export const SD_BTN_PRIMARY =
  'inline-flex items-center justify-center gap-2 rounded-md bg-amp-olive-deep px-3 py-1.5 text-[13px] font-semibold text-amp-cream disabled:opacity-60 dark:bg-amp-olive';

export const SD_BTN_GHOST =
  'inline-flex items-center justify-center gap-1.5 rounded-md border border-amp-line bg-amp-white px-3 py-1.5 text-[13px] font-semibold text-amp-ink hover:bg-amp-cream-warm disabled:opacity-60 dark:border-amp-dark-line dark:bg-amp-dark-surface dark:text-amp-dark-ink dark:hover:bg-amp-dark-surface-warm';

export const SD_BTN_DANGER =
  'inline-flex items-center justify-center gap-1.5 rounded-md border border-red-300 bg-amp-white px-3 py-1.5 text-[13px] font-semibold text-red-700 hover:bg-red-50 disabled:opacity-60 dark:border-red-800 dark:bg-amp-dark-surface dark:text-red-300 dark:hover:bg-red-900/20';

export const SD_CARD =
  'rounded-lg border border-amp-line bg-amp-white p-4 dark:border-amp-dark-line dark:bg-amp-dark-surface';

export const SD_MUTED = 'text-amp-ink-muted dark:text-amp-dark-ink-muted';
export const SD_INK = 'text-amp-ink dark:text-amp-dark-ink';
